import axiosInstance from '@/shared/api/axios';
import type {
  ApiSplitsGetItem,
  ApiSplitsListParams,
  ApiSplitsListResponse,
  ApiSplitsPendingCountResponse,
  ApiSplitsSaveBody,
} from '@/shared/types/api/splits';

export const apiSplitsListGet = async (
  params: ApiSplitsListParams,
): Promise<ApiSplitsListResponse> => {
  const { data } = await axiosInstance.get<ApiSplitsListResponse>('/splits', { params });
  return data;
};

export const apiSplitsDetailGet = async (id: string): Promise<ApiSplitsGetItem> => {
  const { data } = await axiosInstance.get<ApiSplitsGetItem>(`/splits/${id}`);
  return data;
};

export const apiSplitsSave = async (id: string, body: ApiSplitsSaveBody): Promise<ApiSplitsGetItem> => {
  const { data } = await axiosInstance.post<ApiSplitsGetItem>(`/splits/${id}/save`, body);
  return data;
};

export const apiSplitsDelete = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/splits/${id}`);
};

export const apiSplitsPendingCount = async (): Promise<number> => {
  const { data } = await axiosInstance.get<ApiSplitsPendingCountResponse>('/splits/pending-count');
  return data.count;
};
